module.exports = __webpack_public_path__ + "static/media/Shawarma.36cd30e3.png";